<template>
  <div>
    <a-drawer
      width="800"
      title="分配流量"
      placement="right"
      :closable="true"
      v-model:visible="flowRateVisible"
      @close="closeflowRateDrawer"
    >
      <a-progress
        :percent="flowRatePercent"
        :show-info="false"
        class="self-process"
        stroke-linecap="round"
        :status="flowRatePercent > 100 ? 'exception' : 'active'"
      />
      <div
        style="display: flex; justify-content: space-between;margin-top: 10px"
      >
        <p>已占用流量{{ flowRatePercent }}%</p>
        <p>剩余可用流量{{ 100 - flowRatePercent }}%</p>
      </div>
      <div style="margin-top: 20px;">
        <a-table
          size="small"
          :dataSource="flowRateDataSource"
          :columns="columns"
          :pagination="false"
        >
          <template #abStatus="{record}">
            {{ abStatus[record.abStatus] }}
          </template>
          <template #action="{ record }">
            <a-input-number
              id="inputNumber"
              v-model:value="record.weight"
              :min="1"
              :max="100"
              :step="1"
              :precision="0"
              @change="changeWeight(record)"
            />
            %
          </template>
        </a-table>
        <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1
          }"
        >
          <a-button style="margin-right: 8px" @click="flowRateVisible = false"
            >取消</a-button
          >
          <a-button
            :disabled="flowRatePercent > 100"
            type="primary"
            @click="saveFlowRate"
            >保存</a-button
          >
        </div>
      </div>
    </a-drawer>
    <a-drawer
      width="600"
      :title="drawerTitle"
      placement="right"
      :closable="false"
      v-model:visible="createVisible"
      @close="closeCreateDrawer"
    >
      <a-form
        ref="createFormRef"
        :rules="createFormRules"
        :model="createForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="实验层名称" name="name">
          <a-input
            :maxlength="50"
            :disabled="createFormDisabled"
            v-model:value="createForm.name"
          />
        </a-form-item>
        <a-form-item label="分层主体" name="subject">
          <a-radio-group v-model:value="createForm.subject">
            <a-radio :value="1">Distinct Id</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="描述" name="description">
          <a-textarea :maxlength="200" v-model:value="createForm.description" />
        </a-form-item>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button style="margin-right: 8px" @click="closeCreateDrawer"
          >取消</a-button
        >
        <a-button type="primary" @click="saveCreateDrawer">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, inject } from 'vue'
export default defineComponent({
  setup() {
    const initData = inject('initState')
    const state = reactive({
      abStatus: {
        0: '调试中',
        1: '运行中',
        2: '已结束',
        3: '暂停中'
      },
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      },
      columns: [
        {
          title: '实验名称',
          dataIndex: 'abName',
          key: 'abName'
        },
        {
          title: '实验状态',
          dataIndex: 'abStatus',
          key: 'abStatus',
          slots: { customRender: 'abStatus' }
        },
        {
          title: '创建人',
          dataIndex: 'abCreater',
          key: 'abCreater'
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
          width: 140
        }
      ]
    })
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
})
</script>
<style>
.self-process .ant-progress-inner {
  height: 40px;
  border-radius: 0px !important;
}
.self-process .ant-progress-inner .ant-progress-bg {
  height: 40px !important;
  border-radius: 0px !important;
}
</style>
